import React from 'react'
import { Box, Typography } from '@mui/material'

// Opción del combo de transportes: el código y, debajo, la descripción de GP (casi siempre la dirección del depósito)
export const renderTransportOption = (props, option) => (
    <li {...props} key={option.code}>
        <Box>
            <Typography variant="body2">{option.code}</Typography>
            {option.description && (
                <Typography variant="caption" color="text.secondary">{option.description}</Typography>
            )}
        </Box>
    </li>
)
